// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubformNews_wrapper__1e14k","main-description":"SubformNews_main-description__JgHpT","photo-description":"SubformNews_photo-description__11LOu"};